import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getAgents, deleteAgents } from "services/AgentService";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useAuth } from "hooks/useAuth";

const AgentsList = () => {

   const [agents, setAgents] = useState([]);
  const [filteredAgents, setFilteredAgents] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [deleteAgentId, setDeleteAgentId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [agent, setAgent] = useState({});
  const navigate = useNavigate();
  const { hasPermission } = useAuth();

  useEffect(() => {
    getAgentsList();
  }, []);

  useEffect(() => {
    handleSearch();
  }, [searchQuery, agents]);

  const getAgentsList = () => {
    getAgents().then((response) => {
      if (response && response.data.success) {
        setAgents(response.data.agents);
        setFilteredAgents(response.data.agents);
      }
    });
  };

  const handleSearch = () => {
    const query = searchQuery.toLowerCase();
    const filtered = agents.filter(
      (agent) =>
        agent.first_name?.toLowerCase().includes(query) ||
        agent.email?.toLowerCase().includes(query) ||
        agent.phone?.toLowerCase().includes(query)
    );
    setFilteredAgents(filtered);
    setPage(0);
  };

  const handleChangePage = (newPage) => setPage(newPage);
  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };

  const paginatedAgents = filteredAgents.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const handleCreate = () => {
    navigate("/add-agent", { state: { isEdit: false } });
  };

  const handleEdit = (agent) => {
    navigate("/add-agent", { state: { isEdit: true, editFormData: agent } });
  };


  const exportToCSV = () => {
    const csvData = filteredAgents.map((agent) => ({
      "Employee Code": agent.employeeCode,
      "Employee Name": agent.name,
      "Phone No": agent.phone,
      "Email": agent.email,
      "Status": agent.status,
    }));
  
    const worksheet = XLSX.utils.json_to_sheet(csvData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Agents");
  
    const csvOutput = XLSX.write(workbook, {
      bookType: "csv",
      type: "array",
    });
  
    const blob = new Blob([csvOutput], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, "agents_list.csv");
  };
  
  const exportToXLS = () => {
    const xlsData = filteredAgents.map((agent) => ({
      "Employee Code": agent.emp_code,
      "Employee Name": agent.first_name,
      "Phone No": agent.phone,
      "Email": agent.email,
      "Status": agent.status,
    }));  
    const worksheet = XLSX.utils.json_to_sheet(xlsData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Agents");
  
    const xlsOutput = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
  
    const blob = new Blob([xlsOutput], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });
  
    saveAs(blob, "agents_list.xlsx");
  };

  const showAgent = (agent) => {
    setAgent(agent);
  };

  const deleteAgent = (id) => {
    setDeleteAgentId(id);
    setShowDeleteModal(true);
  };
  
  const confirmDeleteAgent = () => {

    deleteAgents(deleteAgentId).then((response) => {
      if (response && response.data.success) {
        setShowDeleteModal(false);
        getAgentsList();
      }
    });
    //setDeleteAgentId(deleteAgentId);
  };


  return (
    <>
      <section className="content-header">
        <div class="header-icon">
          <i class="fa fa-agents"></i>
        </div>
        <div className="header-title">
          <h1>Manage Agents</h1>
          <small>Agents List</small>
        </div>
      </section>

      <section className="content">
        <div className="row">
          <div className="col-lg-12 pinpin">
            <div className="buttonexport" id="buttonlist">
            {hasPermission("Add Agent") && (
              <Link className="btn btn-add" to="/add-agent">              
                <i className="fa fa-plus"></i> Add Agent
              </Link>
            )}
            </div>
            <div className="card lobicard mt-2" data-sortable="true">
              <div className="card-header">
                <div className="card-title custom_title">
                  <h4>Agents List</h4>
                </div>
              </div>
              <div className="card-body">
              <div className="d-flex align-items-center mb-3">
                  <select
                    value={rowsPerPage}
                    onChange={handleRowsPerPageChange}
                    className="form-control w-auto mr-3"
                  >
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </select>

                  <input
                    type="text"
                    placeholder="Search by name, email, or phone"
                    className="form-control w-25 mr-3"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                  <div className="btn-group ml-3">
                    <button
                      className="btn btn-exp btn-sm "
                      data-toggle="dropdown"
                    >
                      <i className="fa fa-bars"></i> Export Table Data
                    </button>
                    <ul className="dropdown-menu exp-drop" role="menu">
                      <li>
                        <a
                          href="#"
                          onClick={exportToCSV}
                        >
                          <img
                            src="assets/dist/img/csv.png"
                            width="24"
                            alt="logo"
                          />{" "}
                          CSV
                        </a>
                      </li>

                      <li class="dropdown-divider"></li>
                      <li>
                        <a
                          href="#"
                          onClick={exportToXLS}
                        >
                          <img
                            src="assets/dist/img/xls.png"
                            width="24"
                            alt="logo"
                          />{" "}
                          XLS
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <hr />

                <div className="table-responsive">
                  <table
                    id="dataTableExample1"
                    className="table table-bordered table-striped table-hover"
                  >
                    <thead className="back_table_color">
                    <tr class="info">                          
                          <th>Agent Name</th>
                          <th>Company Name</th>
                          <th>Contact Number </th>
                          <th>Email id</th>
                          <th>Gst Number</th>
                          
                          <th>View </th>
                          <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                    {filteredAgents.length > 0 ? (
                        filteredAgents.map((agent) => (
                          <tr key={agent.id}>
                            <td>{agent.agent_name}</td>
                            <td>{agent.company_name}</td>                          
                            <td>{agent.contact_number}</td>
                            <td>{agent.email}</td>                           
                            <td>{agent.gst_number}</td>
                            <td>
                            {hasPermission("View Agent") && (
                              <button type="button" className="btn btn-primary btn-sm" data-toggle="modal" data-target="#hotelInfo" onClick={()=>{ showAgent(agent); }}><i className="fa fa-eye"></i> </button>
                            )}
                              </td>
                            <td>
                            {hasPermission("Edit Agent") && (
                              <button
                                type="button"
                                className="btn btn-add btn-sm mr-3"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleEdit(agent);
                                }}
                              >
                                <i className="fa fa-pencil"></i>
                              </button>
                            )}
                             {hasPermission("Delete Agent") && (
                              <button
                                type="button"
                                className="btn btn-danger btn-sm"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  deleteAgent(agent.id);
                                }}
                                data-toggle="modal"
                                data-target="#customer2"
                              >
                                <i className="fa fa-trash-o"></i>
                              </button>
                             )}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="7" className="text-center">
                            No agents found.
                          </td>
                        </tr>
                      )}              

                     
                    </tbody>
                  </table>
                </div>
                {/* Pagination Controls */}
                <div className="d-flex justify-content-between align-items-center mt-3">
                  <span>
                    Showing {page * rowsPerPage + 1} to{" "}
                    {Math.min((page + 1) * rowsPerPage, filteredAgents.length)}{" "}
                    of {filteredAgents.length} entries
                  </span>
                  <div>
                    <button
                      className="btn btn-default btn-sm mr-2"
                      onClick={() => handleChangePage(Math.max(0, page - 1))}
                      disabled={page === 0}
                    >
                      Prev
                    </button>
                    <button
                      className="btn btn-default btn-sm"
                      onClick={() =>
                        handleChangePage(
                          Math.min(
                            Math.floor(filteredAgents.length / rowsPerPage),
                            page + 1
                          )
                        )
                      }
                      disabled={
                        (page + 1) * rowsPerPage >= filteredAgents.length
                      }
                    >
                      Next
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {showDeleteModal && (
        <div className="modal fade show d-block" tabIndex="-1" role="dialog">
          <div
            className="modal-dialog modal-lg"
            role="document"
            style={{ zIndex: "9999" }}
          >
            <div className="modal-content">
              <div className="modal-header modal-header-primary">
                <h3>
                  <i className="fa fa-user m-r-5"></i> Delete Users
                </h3>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-hidden="true"
                  onClick={(e) => {
                    setShowDeleteModal(false);
                  }}
                >
                  ×
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12">
                    <form className="form-horizontal">
                      <div className="row">
                        <div className="col-md-12 form-group user-form-group">
                          <label className="control-label">Delete Users</label>
                          <div className="float-right">
                            <button
                              type="button"
                              className="btn btn-danger btn-sm mr-3"
                              onClick={(e) => {
                                e.stopPropagation();
                                setShowDeleteModal(false);
                              }}
                            >
                              NO
                            </button>
                            <button
                              type="button"
                              className="btn btn-add btn-sm"
                              onClick={(e) => {
                                e.stopPropagation();
                                confirmDeleteAgent();
                              }}
                            >
                              YES
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-danger float-left"
                  data-dismiss="modal"
                  onClick={(e) => {
                    setShowDeleteModal(false);
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

{/*{showDeleteModal && ( */}
       
         <div className="modal fade" id="hotelInfo" tabindex="-1" role="dialog" aria-hidden="true">
                  <div className="modal-dialog modal-lg">
                     <div className="modal-content">
                        <div className="modal-header modal-header-primary">
                           <h3><i className="fa fa-user m-r-5"></i> Agent Information</h3>
                           <button type="button" className="close" data-dismiss="modal" aria-hidden="true">×</button>
                        </div>
                       <div className="modal-body">
                        <table className="table px-3">
                           
                           <tbody>
                             <tr>
                               
                            
                               <td>
                                 <p className="mb-1"><strong> Agent Name </strong></p>
                                 <p className="mb-0">{agent.agent_name}</p>
                               </td>
                               <td>
                                 <p className="mb-1"><strong> Company Name </strong></p>
                                 <p className="mb-0">{agent.company_name}</p>
                               </td>
                             </tr>

                             <tr>
                              <td>
                                <p className="mb-1"><strong> Billing Address </strong></p>
                                <p className="mb-0">{agent.billing_address}</p>
                              </td>
                              <td>
                                 <p className="mb-1"><strong> Contact Number  </strong></p>
                                 <p className="mb-0">{agent.contact_number}</p>
                               </td>
                             
                            </tr>

                            <tr >
                              <td>
                                 <p className="mb-1"><strong> Email id </strong></p>
                                 <p className="mb-0">{agent.email}</p>
                               </td>
                              <td>
                                <p className="mb-1"><strong> State </strong></p>
                                <p className="mb-0">{agent.state}</p>
                              </td>
                            </tr>
                            
                            <tr>
                              <td>
                                 <p className="mb-1"><strong>	City </strong></p>
                                 <p className="mb-0">{agent.city}</p>
                               </td>
                               <td>
                                 <p className="mb-1"><strong> Gst Number </strong></p>
                                 <p className="mb-0">{agent.gst_number}</p>
                               </td>
                            </tr>                         

                           </tbody>
                         </table>
                        </div> 
                        <div className="modal-footer">
                           <button type="button" className="btn btn-danger float-left" data-dismiss="modal">Close</button>
                        </div>
                     </div>
                     
                  </div>
                  
               </div>
  {/*    )}*/}
    </>
  );
};

export default AgentsList;
